(() => {
  const moveMaterialStory = () => {
    const story = document.querySelector(
      '.elli-material-story[data-ui-component="Elli Material Story"]',
    );
    if (!story) return;

    const recommendations = document.querySelector(
      '[id$="__elli_pdp_recs"], #shopify-section-elli_pdp_recs',
    );
    if (recommendations) {
      recommendations.insertAdjacentElement("afterend", story);
      return;
    }

    const main = document.getElementById("mainContent") || document.querySelector("main");
    if (main) main.appendChild(story);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", moveMaterialStory, {
      once: true,
    });
  } else {
    moveMaterialStory();
  }
})();
